import axios from "axios";

import api from "./apiService";

import { login as loginToken, getToken } from "./tokenService";
import { setItem, getItem } from "./localStorageService";

const PoliticaService = {
    buscarTodas: async (
        pagina = 1,
        limite = 1000,
        busca = undefined
    ) => {
        const usuarioPerfil = getItem(process.env.REACT_APP_PERFIL_KEY);
        // 1 === ADMIN
        if (usuarioPerfil == 1) {
            const params = [];

            if (pagina && pagina != "") {
                params.push(`pagina=${pagina}`);
            }

            if (limite && limite != "") {
                params.push(`limite=${limite}`);
            }

            if (busca && busca != "") {
                params.push(`busca=${busca}`);
            }

            let res = await api.get("/empresa/modelo/admin");
            
            return {
                politicas: res.data,
                total: res.headers["x-total-count"],
            };
        }
    },

    buscarPorEmpresa: async (
        empresaId = undefined
    ) => {
        const usuarioPerfil = getItem(process.env.REACT_APP_PERFIL_KEY);
        // 1 === ADMIN
        if (usuarioPerfil == 1 && empresaId != undefined) {
            
            let res = await api.get(
                `/empresa/politica/admin/${empresaId}`
            );

            return {
                politicas: res.data,
                total: res.headers["x-total-count"]
            };
        }
    },

    adicionarPolitica: async (politica) => {
        const usuarioPerfil = getItem(process.env.REACT_APP_PERFIL_KEY);
        // 1 === ADMIN
        if (usuarioPerfil == 1) {
            try {
                let res = await api.post("empresa/politica/admin", politica);
                return res.data
            } catch (error) {
                return error;
            }
        }
    },

    editarPolitica: async (politica) => {
        const usuarioPerfil = getItem(process.env.REACT_APP_PERFIL_KEY);
        // 1 === ADMIN
        if (usuarioPerfil == 1) {
            try {
                let res = await api.put("empresa/politica/admin", politica);
                return res.data
            } catch (error) {
                return error;
            }
        }
    }
};

export default PoliticaService;